/**
 * @module Mapping
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    namespaced: true,
    state: {
        triggerForMappingIncome: false, // useful to trigger update in /operation/detail/{id} for mapping
        showModal: false,
        showModalZone: false,
        id: 0,
        formData: [],
        cityData: [],
        regionCode: '',
        city_id: 0,
        zone_id: 0,
        myErrors: [],
        showMapCard: true,
        showZoneCard: false,
        showMappingCard: false,
        showMappingListCard: false,
        showMappingListByRegionCard: true,
        showMappedZoneCard: false,
        showArchive: false,
        showArchiveSub: false,
        mappingData: [],
        mappingList: [],
        mappingListByRegion: [],
        zoneListByCity: [],
        editMode: false,
        readModeCSS: 'abtg__row-readmode',
        cityLabel: '',
        saveOk: false,
        mqRange: 50,
        ac: {
            0: 'active',
            50: '',
            70: '',
            90: '',
            110: '',
            111: '',
            1000: '',
            1001: '',
            1002: '',
        },


        showModalUpload: false,
        mappingId: 0,
        operationId: 0,
        fileList: [],
        imagesList: [],
        fileData: [],

        bread_list: [],
        bread_active: '',
        submitType: null,
        idZoneToDelete: null,
        showDeleteZoneAlert: false,
        idBuildingToDelete: null,
        idBuilding: null,
        idToDelete: 0,

        customRange: [],
        rotateSpin: '',
        rotateColorSpin: '',
        showBinIcon: false,
        streetPrice: '',


    },
    getters: {
        getField,
        priceMq: state => {
            let total = 0;
            let count = 0;
            state.mappingList.forEach(function (record) {
                if (record.active === 1) {
                    count++;
                    let pmq = (record.prezzo / record.mq);
                    total = (total * 10 + pmq * 10) / 10;
                }

            });
            total = (total / count);
            return total;

        },

        // streetPrice: state => {
        //     let total = 0;
        //     let count = 0;
        //     state.mappingList.forEach(function (record) {
        //         if (record.active === 1) {
        //             count++;
        //             let pmq = (record.prezzo / record.mq);
        //             total = (total * 10 + pmq * 10) / 10;
        //         }
        //     });
        //     total = (((total / count) * 70) / 100).toFixed(2);
        //     return total;
        // }

    },
    mutations: {
        updateField,
        onOffEditModeSet: function (state, boolean) {
            state.editMode = boolean;
            if (boolean === true) {
                state.readModeCSS = '';
            } else {

                state.readModeCSS = 'abtg__row-readmode';
            }
        },

        regionCodeSet: function (state, data) {
            if (data) {
                state.regionCode = data;
            }

        },
        zoneSet: function (state, data) {
            state.zone_id = data;
        },
        cityIdSet: function (state, data) {
            state.city_id = data;
        },
        cityDataSet: function (state, data) {
            state.cityData = data;
        },
        myErrors: function (state, data) {
            state.myErrors = data;
        },
        zeroStepCard: function (state) {
            state.showMapCard = true;
            state.showZoneCard = false;
            state.showMappingCard = false;
            state.showMappingListCard = false;
            //  state.showMappingListByRegionCard = false;
        },
        firstStepCard: function (state) {
            state.showMapCard = false;
            state.showZoneCard = true;
            state.showMappingListByRegionCard = true;
            state.showMappingCard = false;
            state.showMappingListCard = false;
        },
        secondStepCard: function (state) {
            state.showZoneCard = false;
            state.showMappingCard = true;
            state.showMappingListCard = true;
        },
        thirdStepCard: function (state) {
            state.showMapCard = false;
            state.showZoneCard = false;
            state.showMappingCard = true;
            state.showMappingListCard = true;
        },
        archiveStepCard: function (state) {
            state.showMappingListByRegionCard = true;
            state.showMappedZoneCard = false;
        },
        archive2StepCard: function (state) {
            state.showMappingListByRegionCard = false;
            state.showMappedZoneCard = true;
        },
        bigArchiveStepOne: function (state) {

            state.showArchive = true;
            state.showArchiveSub = false;
        },
        bigArchiveStepTwo: function (state) {
            state.showArchive = false;
            state.showArchiveSub = true;
        },
        bigArchiveOff: function (state) {
            state.showMappedZoneCard = true;
            state.showArchive = false;
            state.showArchiveSub = false;
        },

        offArchiveMap: function (state) {

            state.showArchive = false;
        },


        mappingDataSet: function (state, data) {
            state.mappingData = data;
        },

        mappingListSet: function (state, data) {
            state.mappingList = data;
        },
        mappingListByRegionSet: function (state, data) {
            state.mappingListByRegion = data;
        },
        zoneListByCitySet: function (state, data) {
            state.zoneListByCity = data;
        },
        cityLabelSet: function (state, data) {
            state.cityLabel = data;
        },
        mappedBuildingDetailSet: function (state, data) {
            state.formData = {
                address: data.via,
                mq: data.mq,
                price: data.prezzo,
                room: data.locali,
                floor: data.piano,
                lift: data.ascensori,
                bathroom: data.bagni,
                renovation: data.ristrutturazione,
                date: data.data,
                link: data.myLink,
                note: data.note,
                broken_link: data.broken_link,
            }
        },
        mqRange: function (state, data) {
            for (var k in state.ac) {
                state.ac[k] = '';
            }


            if (data == undefined) {
                data = 0;
            }


            state.ac[data] = 'active';

        },

        saveOkSet: function (state, boolean) {
            state.saveOk = boolean;
        },

        showModalUploadSet: function (state) {
            state.showModalUpload = !state.showModalUpload;
        },
        mappingIdSet: function (state, data) {
            state.mappingId = data;
        },
        operationIdSet: function (state, data) {
            state.operationId = data;

        },


        fileListSet: function (state, data) {
            state.fileList = data.docs;
            state.imagesList = data.images;
        },
        /*
         * Setting file for modal upload to modify/delete
         */
        singleFileSet: function (state, data) {
            state.fileData = data;
        },

        breadStep1Set: function (state) {
            state.bread_active = {
                'label': 'Mappatura Start'
            };

            state.bread_list = {
                0: {

                    'label': 'Nuova operazione'
                }
            }
        },

        breadStep2Set: function (state) {
            state.bread_active = {
                'label': 'Scegli la città e la zona'
            };
            state.bread_list = {
                0: {

                    'label': 'Nuova operazione'
                },
                1: {

                    'action': 1,
                    'label': 'Mappatura Start'
                }
            }
        },

        breadStep3Set: function (state) {
            state.bread_active = {
                'label': 'Mappa gli immobili'
            };
            state.bread_list = {
                0: {
                    'label': 'Nuova operazione'
                },
                1: {
                    'action': 1,
                    'label': 'Mappatura Start'
                },
                2: {
                    'action': 2,
                    'label': 'Scegli la città e la zona'
                }
            }
        },
        setData: function (state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        cityList: function (state, regionCode) {
            state.commit('regionCodeSet', regionCode);
            axios.get('/api/v1/cities/' + regionCode)
                .then(function (response) {
                    state.commit('cityDataSet', response.data);
                    state.dispatch('mappingListByRegion', regionCode);
                    state.commit('firstStepCard');
                    state.commit('breadStep2Set');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        editZoneData: function (state, data) {
            axios.post('/api/v1/mapping/editZoneData', data)
                .then(function (response) {

                })
        },

        sendZoneData: function (state) {

            state.commit('cityIdSet', state.state.city_id);

            axios.post('/api/v1/mapping/sendZoneData', {
                macrozone: state.state.macrozone,
                microzone: state.state.microzone,
                zone: state.state.zone,
                city_id: state.state.city_id,
                region: state.state.regionCode,
            })
                .then(function (response) {
                    state.commit('regionCodeSet', state.state.regionCode);

                    switch (state.state.submitType) {
                        case 'draw':
                            window.location.href = '/mapping/building_import/' + response.data + '/' + state.state.regionCode;
                            break;
                        case 'manual':
                            state.dispatch('openModal');
                            state.dispatch('mappingData', response.data);
                            state.dispatch('mappingListByRegion', state.state.regionCode);
                            break;

                        case 'scan':
                            window.location.href = '/mapping/building_import/' + response.data + '/' + state.state.regionCode + '/?mode=scan';
                            break;
                    }


                }).catch(function (error) {
                state.commit('myErrors', error.response.data.errors);
            })
        },

        mappingData: function (state, id) {
            state.commit('zoneSet', id);
            axios.get('/api/v1/mapping/' + id)
                .then(function (response) {
                    state.commit('cityIdSet', response.data.zoneData.city_id);
                    state.commit('mappingDataSet', response.data.zoneData);
                    state.commit('secondStepCard');
                    state.commit('breadStep3Set');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        clearForm: function (state) {
            state.state.formData = {
                address: ' ',
                mq: ' ',
                price: ' ',
                room: ' ',
                floor: ' ',
                lift: ' ',
                bathroom: ' ',
                renovation: ' ',
                link: ' ',
                note: ' ',
                id: 0
            }
        },

        sendMappingData: function (state) {
            let mqRange = mixin.methods.WHICH_ACTIVE_TAB(state.state.formData.mq);
            axios.post('/api/v1/mapping/sendMappingData', {
                via: state.state.formData.address,
                mq: mixin.methods.REMOVE_DOT(state.state.formData.mq),
                prezzo: mixin.methods.REMOVE_DOT(state.state.formData.price),
                locali: mixin.methods.REMOVE_DOT(state.state.formData.room),
                piano: mixin.methods.REMOVE_DOT(state.state.formData.floor),
                ascensori: state.state.formData.lift,
                bagni: mixin.methods.REMOVE_DOT(state.state.formData.bathroom),
                ristrutturazione: state.state.formData.renovation,
                data: state.state.formData.date,
                link: state.state.formData.link,
                note: state.state.formData.note,
                zone_id: state.state.zone_id,
                city_id: state.state.city_id,
                id: state.state.id,
            })
                .then(function () {

                    state.state.myErrors = [];
                    state.commit('mqRange', mqRange);
                    // note: mqRange is useful to load directly the right time after insert/update data
                    state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: mqRange});
                    state.commit('saveOkSet', true);
                    state.dispatch('offMsg');
                    state.dispatch('clearForm');
                    state.commit('thirdStepCard');
                    if (state.state.triggerForMappingIncome === true) // when this method is called from mapping income we need to update building data card (top of page)
                    {
                        state.dispatch('operation/retrievedMappedBuilding', state.state.id, {root: true});
                    }
                    state.state.id = 0;

                })
                .catch(error => {
                    if (error.response) {
                        state.commit('myErrors', error.response.data.errors);
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        rangeMqCustom: function (state, data) {
            axios.get('/api/v1/mapping/rangeMq/' + state.state.zone_id)
                .then(response => {
                    state.commit('setData', {data: response.data, name: 'customRange'});
                })
        },

        mappingList: function (state, data) {
            axios.get('/api/v1/mapping/mappingList/' + data.zone_id + '/' + data.mqRange)
                .then(function (response) {
                    state.commit('mqRange', data.mqRange);
                    state.commit('mappingListSet', response.data.data);
                    state.commit('setData', {data: response.data.streetPrice, name: 'streetPrice'})

                    state.dispatch('rangeMqCustom');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        mappingListByRegion: function (state, regionCode) {
            axios.get('/api/v1/mapping/mappingListByRegion/' + regionCode)
                .then(function (response) {
                    state.commit('mappingListByRegionSet', response.data.data);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        retrieveZones: function (state, data) {

            axios.get('/api/v1/mapping/retrieveZone/' + data.city_id)
                .then(function (response) {
                    state.commit('zoneListByCitySet', response.data);
                    state.commit('cityLabelSet', data.cityLabel);
                    state.dispatch('openModalZone');
                    //state.commit('archive2StepCard');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        bigArchiveMappingListByRegion: function (state, regionCode) {
            axios.get('/api/v1/mapping/mappingListByRegion/' + regionCode)
                .then(function (response) {

                    state.commit('mappingListByRegionSet', response.data.data);
                    state.commit('bigArchiveStepOne');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        bigArchiveRetrieveZones: function (state, data) {
            axios.get('/api/v1/mapping/retrieveZone/' + data.city_id)
                .then(function (response) {
                    state.commit('zoneListByCitySet', response.data);
                    state.commit('cityLabelSet', data.cityLabel);
                    state.commit('bigArchiveStepTwo');
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        hideBigArchiveMappendZone: function (state) {
            state.commit('bigArchiveStepOne');
        },

        hideMappedZone: function (state) {
            state.commit('archiveStepCard');
        },

        listMappedBuilding: function (state, data) {
            state.dispatch('mappingData', data.zone_id);
            state.dispatch('mappingList', {zone_id: data.zone_id});
            state.commit('bigArchiveOff');
            state.commit('thirdStepCard');
            if (data.region) {
                state.commit('regionCodeSet', data.region);
                state.dispatch('mappingListByRegion', data.region);
            }

        },

        retrieveMappedBuilding: function (state, id) {
            state.state.id = id;
            axios.get('/api/v1/mapping/retrieveMappedBuilding/' + id)
                .then(function (response) {
                    state.dispatch('onOffEditMode', true);
                    state.dispatch('openModal');
                    state.commit('mappedBuildingDetailSet', response.data);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        insertResource: function (state) {
            state.dispatch('clearForm');
            state.dispatch('onOffEditMode', true);
            state.dispatch('openModal');
        },

        activateDeactivate: function (state, data) {
            axios.get('/api/v1/mapping/activateDeactivate/' + data.id)
                .then(function () {
                    state.dispatch('mappingList', {zone_id: data.zone_id, mqRange: data.mqRange})
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        offArchiveMap: function (state) {

            state.commit('breadStep1Set');
            state.commit('offArchiveMap');
        },

        closeModal: function (state) {
            state.state.id = 0;
            state.state.showModal = false;
        },

        openModal: function (state) {
            state.state.showModal = true;
        },

        closeModalZone: function (state) {
            state.state.showModalZone = false;
        },

        openModalZone: function (state) {
            state.state.showModalZone = true;
        },

        offMsg: function (state) {
            setTimeout(function () {
                state.commit('saveOkSet', false);
            }, 1000);

            setTimeout(function () {
                state.state.showModal = false;
            }, 2000)

        },

        onOffEditMode: function (state, boolean) {
            state.commit('onOffEditModeSet', boolean);
        },

        triggerModalUpload: function (state) {
            state.commit('showModalUploadSet');
        },

        fileList: function (state, data) {
            axios.get('/api/v1/mapping_income/' + data.mappingId + '/showOperation')
                .then(function (response) {
                    state.commit('operationIdSet', response.data.id);
                    state.commit('mappingIdSet', data.mappingId);
                    axios.get('/api/v1/custom/fileList/' + state.state.operationId)
                        .then(function (response) {
                            state.commit('fileListSet', response.data);
                        })
                });
        },

        sendUploadFile: function (state) {
            let forma = new FormData();
            forma.append('file', state.state.myFileUpload);
            forma.append('descrizione', state.state.myDescriptionUpload);
            forma.append('operazione_id', state.state.operationId);
            forma.append('id', state.state.myFileIdUpload);
            axios.post('/api/v1/custom/sendUploadFile', forma,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(function () {
                    state.dispatch('triggerModalUpload');
                    state.dispatch('fileList', {mappingId: state.state.mappingId});
                })
        },

        /*
         * Retrieve file used in modal upload to modify/delete it
         */
        retrieveFile: function (state, id) {
            axios.get('/api/v1/custom/retrieveFile/' + id)
                .then(function (response) {
                    state.commit('singleFileSet', response.data);
                    state.dispatch('upload/settingFileData', state.state.fileData, {root: true});
                    state.dispatch('triggerModalUpload')
                })
        },

        removeFile: function (state) {
            axios.get('/api/v1/custom/removeFile/' + state.state.fileId)
                .then(function () {
                    state.dispatch('fileList', {mappingId: state.state.mappingId});
                })
        },

        breadForceStep(state, whichStep) {

            if (whichStep === 1) {
                state.commit('offArchiveMap');
                state.dispatch('mappingListByRegion', ''); // reset regionCode
                state.commit('zeroStepCard');
            }
            if (whichStep === 2) {
                state.commit('firstStepCard');
                state.dispatch('mappingListByRegion', state.state.regionCode);
            }
            state.commit('breadStep' + whichStep + 'Set');
        },

        deleteZone: function (state) {
            axios.get('/api/v1/mapping/deleteZone/' + state.state.idZoneToDelete)
                .then(function (response) {
                    state.state.showDeleteZoneAlert = false;
                    state.state.zoneListByCity = state.state.zoneListByCity.filter(function (v) {

                        return v.id != state.state.idZoneToDelete;
                    });
                    state.state.idZoneToDelete = null;
                })
        },

        deleteSingleBuilding: function (state) {
            axios.get('/api/v1/mapping/deleteSingleBuilding/' + state.state.idToDelete)
                .then(function (response) {
                    state.dispatch('mappingListByRegion', response.data);
                    if (state.state.zone_id > 0) {
                        // reset after deleting to tab "all"
                        state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                    }
                })
        },

        deleteBuildingsAndZone: function (state) {
            axios.get('/api/v1/mapping/deleteBuildingsAndZones/' + state.state.idBuildingToDelete + '/' + state.state.regionCode)
                .then(function (response) {
                    state.dispatch('mappingListByRegion', response.data);
                    if (state.state.zone_id > 0) {
                        // reset after deleting to tab "all"
                        state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                    }
                })
        },

        createOperation: function (state) {
            axios.get('/api/v1/mapping/createOperation/' + state.state.idBuilding)
                .then(function (response) {
                    window.location.href = "/custom/" + response.data.idBuilding + '/' + response.data.idOperation;
                })
        },

        exportExcel: function (state) {
            axios.get('/api/v1/mapping/exportExcel/' + state.state.zone_id)
                .then(response => {
                    window.location.href = '/storage/' + response.data + '/' + state.state.zone_id + '_mapping.xlsx';
                })

        },

        saveCustomRangeData: function (state, data) {
            data.zone_id = state.state.zone_id;
            axios.post('/api/v1/mapping/saveCustomRangeData', data)
                .then(response => {
                    state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                })
        },

        deleteCustomRange: function (state, data) {
            axios.get('/api/v1/mapping/deleteCustomRange/' + data)
                .then(response => {
                    state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                })
        },

        deleteAdsOutdated: function (state) {
            axios.get('/api/v1/buildingImport/deleteAdsOutdated/' + state.state.zone_id)
                .then(response => {
                    state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                    state.state.rotateSpin = '';
                    state.state.rotateColorSpin = '';
                    state.state.showBinIcon = false;
                })
        },

        checkAds: function (state) {
            state.state.rotateSpin = ' fa-spin';
            state.state.showBinIcon = false;
            state.state.rotateColorSpin = ' background-color:red !important';
            axios.get('/api/v1/buildingImport/checkAds/' + state.state.zone_id)
                .then(response => {
                    state.dispatch('mappingList', {zone_id: state.state.zone_id, mqRange: 0})
                    state.state.rotateSpin = '';
                    state.state.rotateColorSpin = '';
                    state.state.showBinIcon = true;
                })
        }

    }
}